// ArcPilot brand mark — the gradient "A" pulled from arcpilot.ai. Two
// triangular shapes (left leg + lower-right wing) overlapping into a
// stylized A, with a multi-stop orange → magenta → purple → cyan
// gradient. Backed by the PNG asset in client/public so the gradient
// stays pixel-faithful to the source brand.
import React from 'react';

interface Props {
  height?: number;
  // `dark` uses the cyan-tipped gradient (the more colourful version);
  // `light` drops cyan and ends on purple. Defaults to `dark` because
  // it reads better against both light and dark backgrounds.
  variant?: 'dark' | 'light';
  title?: string;
  className?: string;
  style?: React.CSSProperties;
}

const NATIVE_W = 284;
const NATIVE_H = 256;

const ArcPilotLogo: React.FC<Props> = ({
  height = 24, variant = 'dark', title = 'ArcPilot', className, style,
}) => {
  const src = variant === 'light'
    ? '/arcpilot-mark-light.png'
    : '/arcpilot-mark-dark.png';
  const width = Math.round(height * (NATIVE_W / NATIVE_H));
  return (
    <img
      src={src}
      alt={title}
      width={width}
      height={height}
      className={className}
      style={{ display: 'block', ...style }}
    />
  );
};

export default ArcPilotLogo;
